import React from 'react';
import {useInView, type IntersectionOptions} from 'react-intersection-observer';
import {useTransition, useLocation} from '@remix-run/react';

//components
import {LoadingSpinner} from 'components/global/LoadingSpinner';

//domains
import {
  filterInputToParams,
  PRODUCT_PER_PAGE,
  PRODUCT_PER_PAGE_WITHOUT_ADS,
} from 'domains/collections';

interface Props {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalProducts: number;
  fetchProducts: (query: string) => void;
  hasAds: boolean;
}

export default function CollectionInfinitiyScroll({
  currentPage,
  setCurrentPage,
  totalProducts,
  fetchProducts,
  hasAds,
}: Props) {
  const {ref, inView} = useInView();

  const location = useLocation();
  const params = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const productPerPage = hasAds
    ? PRODUCT_PER_PAGE
    : PRODUCT_PER_PAGE_WITHOUT_ADS;
  const maxRounds = Math.ceil(totalProducts / productPerPage);

  React.useEffect(() => {
    if (inView && currentPage < maxRounds) {
      const nextPage = currentPage + 1;
      setCurrentPage(() => nextPage);
      const newParams = filterInputToParams('PAGE', {nextPage}, params, 'page');
      const query = `${location.pathname}?${newParams?.toString()}`;
      fetchProducts(query);
    }
  }, [inView]);

  return (
    <div ref={ref} className="my-10 lg:hidden flex items-center justify-center">
      {currentPage < maxRounds && (
        <LoadingSpinner className=" text-hk-orange" width="w-14" />
      )}
    </div>
  );
}
